import img1 from "./hov-1.jpg";
import img2 from "./hov-2.jpg";
import img3 from "./hov-3.jpg";
import img4 from "./hov-4.jpg";
import img5 from "./hov-5.jpg";
import img6 from "./hov-6.jpg";
import img7 from "./hov-7.jpg";
import img8 from "./hov-8.jpg";
import img9 from "./hov-9.jpg";
import img10 from "./hov-10.jpg";
import img11 from "./hov-11.jpg";
import img12 from "./hov-12.jpg";
import img13 from "./hov-13.jpg";
import img14 from "./hov-14.jpg";
import img15 from "./hov-15.jpg";
import img16 from "./hov-16.jpg";
import img17 from "./hov-17.jpg";
import img18 from "./hov-18.jpg";
import img19 from "./hov-19.jpg";
import img20 from "./hov-20.jpg";
import img21 from "./hov-21.jpg";
import img22 from "./hov-22.jpg";
import img23 from "./hov-23.jpg";
import img24 from "./hov-24.jpg";
import img25 from "./hov-25.jpg";
import img26 from "./hov-26.jpg";
import img27 from "./hov-27.jpg";
import img28 from "./hov-28.jpg";
import img29 from "./hov-29.jpg";
import img30 from "./hov-30.jpg";
import img31 from "./hov-31.jpg";
import img32 from "./hov-32.jpg";
import img33 from "./hov-33.jpg";
import img34 from "./hov-34.jpg";
import img35 from "./hov-35.jpg";
import img36 from "./hov-36.jpg";
import img37 from "./hov-37.jpg";
import img38 from "./hov-38.jpg";
import img39 from "./hov-39.jpg";
import img40 from "./hov-40.jpg";
import img41 from "./hov-41.jpg";
import img42 from "./hov-42.jpg";
import img43 from "./hov-43.jpg";
import img44 from "./hov-44.jpg";
import img45 from "./hov-45.jpg";
import img46 from "./hov-46.jpg";
import img47 from "./hov-47.jpg";
import img48 from "./hov-48.jpg";
import img49 from "./hov-49.jpg";
import img50 from "./hov-50.jpg";
import img51 from "./hov-51.jpg";
import img52 from "./hov-52.jpg";

import fp1f3d from "./fp-1f-3d.jpg";
import fp2f3d from "./fp-2f-3d.jpg";
import fp1f2d from "./fp-1f-2d.jpg";
import fp2f2d from "./fp-2f-2d.jpg";

export const hovorcoviceImages = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27, img28, img29, img30,
  img31, img32, img33, img34, img35, img36, img37, img38, img39, img40,
  img41, img42, img43, img44, img45, img46, img47, img48, img49, img50,
  img51, img52,
];

export const hovorcoviceFloorPlans = [
  { image: fp1f3d, label: "1. patro – 3D" },
  { image: fp2f3d, label: "2. patro – 3D" },
  { image: fp1f2d, label: "1. patro – 2D" },
  { image: fp2f2d, label: "2. patro – 2D" },
];
